import { render, staticRenderFns } from "./folderTreeManager.vue?vue&type=template&id=2fce812b&scoped=true"
import script from "./folderTreeManager.vue?vue&type=script&lang=js"
export * from "./folderTreeManager.vue?vue&type=script&lang=js"
import style0 from "./folderTreeManager.vue?vue&type=style&index=0&id=2fce812b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce812b",
  null
  
)

export default component.exports